import { StudentSkillStates } from '../models/StudentSkillState';
import { onlyNotPassed } from './onlyNotPassed';

//const MAX_CARDS_QUANTITY = 3;

export const filterAndSliceSuggested = (element: StudentSkillStates[]) => {
  return { element: element.filter(onlyNotPassed) };
};
